export class SelectUI {
  public static DEFAULT_IDX = "0";
  public static DEFAULT_LANG = "en";
}
